import { NEW_REQUESTS, REMOVE_NEW_REQUESTS, ONGOING_REQUESTS, REMOVE_ONGOING_REQUESTS, CONCLUDED_REQUESTS, REMOVE_CONCLUDED_REQUESTS } from '../constants/actionTypes'

const requestActions = (requests = { new: [], ongoing: [], concluded: [] }, action) => {
    switch (action.type) {
        case NEW_REQUESTS:
            return {...requests, new:[...requests.new, ...action?.payload]}
        case REMOVE_NEW_REQUESTS:
            const newIndex = requests.new.findIndex((request) => 
                request._id === action.id
            )
            let newQuotes = [...requests.new]

            if(newIndex !== -1) {
                newQuotes.splice(newIndex, 1)
            }
            
            return {...requests, new: newQuotes}
        case ONGOING_REQUESTS:
            return {...requests, ongoing:[...requests.ongoing, ...action?.payload]}
        case REMOVE_ONGOING_REQUESTS:
            const unassignedIndex = requests.ongoing.findIndex((request) => 
                request._id === action.id
            )
            let unassignedQuotes = [...requests.ongoing]

            if(unassignedIndex !== -1) {
                unassignedQuotes.splice(unassignedIndex, 1)
            }
            
            return {...requests, ongoing: unassignedQuotes}
        case CONCLUDED_REQUESTS:
            return {...requests, concluded:[...requests.concluded, ...action?.payload]}
        case REMOVE_CONCLUDED_REQUESTS:
            const urgentIndex = requests.concluded.findIndex((request) => 
                request._id === action.id
            )
            let urgentQuotes = [...requests.concluded]

            if(urgentIndex !== -1) {
                urgentQuotes.splice(urgentIndex, 1)
            }
            
            return {...requests, concluded: urgentQuotes}
        default:
            return requests;
    }
}

export default requestActions